import { ValidationObject } from 'app/services/validation.service';
import { ValidatorDataInterface } from 'app/shared/interfaces/ValidatorData.interface';

export default function validateMotorcycleVin(
  data: ValidatorDataInterface
): ValidationObject {
  return {
    key: 'invalid_motorcycle_vin',
    valid: isVinValid(data.value.toString()),
  };
}

export function isVinValid(vin: string): boolean {
  if (!vin) {
    return false;
  }

  const reg = /^(?!.*[IOQ])[A-HJ-NPR-Z0-9]{4,17}$/i;

  return reg.test(vin);
}

export function containsValidVinCharacters(vin: string): boolean {
  return /^(?!.*[IOQ])[A-HJ-NPR-Z0-9]+$/i.test(vin);
}
